<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="问卷名称">
              <a-input
                placeholder="请输入问卷名称"
                v-model="queryParam.questionnaireName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="问卷类型">
              <a-select
                placeholder="请选择问卷类型"
                v-model="queryParam.customerType"
              >
                <a-select-option :value="1">个人</a-select-option>
                <a-select-option :value="0">机构</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="是否启用">
              <a-select
                placeholder="请选择是否启用"
                v-model="queryParam.status"
              >
                <a-select-option :value="1">启用</a-select-option>
                <a-select-option :value="0">不启用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />批量删除</a-menu-item
          >
        </a-menu>

        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="status" slot-scope="text, record">
          <a-switch
            v-model="record.status"
            checked-children="已启用"
            un-checked-children="未启用"
            @click="checked => handleStatus(checked, record)"
          />
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleParticulars(record)">问卷详情</a>
          <a-divider type="vertical" />
          <a @click="handlDelete(record)">删除</a>
          <a-divider type="vertical" />
          <a @click="exportFile(record)">导入</a>
        </span>
      </a-table>
    </div>
    <a-modal
      title="上传文件"
      :visible="exportVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <form action="">
        <a-form-item label="上传文件">
          <a-upload
            name="file"
            :multiple="true"
            accept=".xls,.xlsx"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :remove="handleRemove"
          >
            <a-button> <a-icon type="upload" />选择文件</a-button>
          </a-upload>

          <a
            @click="handleExportExcel('风险测评')"
            href="javascript:;"
            style="padding-left: 10px"
            >点击下载模板</a
          >
        </a-form-item>
      </form>
    </a-modal>
    <riskEvaluationModel
      ref="modalForm"
      @ok="modalFormOk"
      :idns="idns"
    ></riskEvaluationModel>
    <particulars ref="questionnaire" :particulars="particulars"></particulars>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import JDate from '@/components/jeecg/JDate';
import riskEvaluationModel from './riskEvaluationModel';
import particulars from './particulars';
import { filterObj } from '@/utils/util';
// import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import {
  uploadAction,
  postAction,
  getAction,
  postTag,
  downFile
} from '@/api/manage';

export default {
  name: 'ProductsQuotationList',
  // mixins: [JeecgListMixin],
  components: {
    JDate,
    riskEvaluationModel,
    particulars
  },
  data() {
    return {
      wid: '',
      exportVisible: false,
      description: '产品报价管理页面',
      fileList: [],
      showDialog: false,
      showLead: false,
      uploading: false,
      visibleShow: false,
      loading: false,
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      idns: 0,
      particulars: [], //问卷详情数据
      queryParam: {
        questionnaireName: '',
        customerType: undefined,
        status: undefined
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表头
      columns: [
        {
          title: '问卷名称',
          align: 'center',
          dataIndex: 'questionnaireName'
        },
        {
          title: '问卷类型',
          align: 'center',
          dataIndex: 'customerType',
          customRender: text => {
            if (text == 1) {
              return '个人';
            } else if (text == 0) {
              return '机构';
            }
          }
        },
        {
          title: '是否启用',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: {
            customRender: 'status'
          }
          // customRender: text => {
          //   if (text == 0) {
          //     return false;
          //   }
          //   if (text == 1) {
          //     return true;
          //   }
          // }
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        batchLoadUrl:
          process.env.VUE_APP_CMS_CONTENT + '/cont/record/exportXls',
        publishStatus:
          process.env.VUE_APP_CMS_CONTENT + '/cont/questionnaire/publish',
        exportXlsUrl:
          process.env.VUE_APP_CMS_CONTENT + '/cont/problem/export/template',
        importExcelUrl:
          process.env.VUE_APP_CMS_CONTENT + '/cont/problem/import/excel',
        list: process.env.VUE_APP_CMS_CONTENT + '/cont/questionnaire/list',
        delete: process.env.VUE_APP_CMS_CONTENT + '/cont/questionnaire/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/cont/questionnaire/deleteBatch',
        particulars:
          process.env.VUE_APP_CMS_CONTENT + '/cont/questionnaire/info'
      },
      dictOptions: {},
      superFieldList: []
    };
  },
  created() {
    this.getList();
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  methods: {
    handleStatus(checked, record) {
      postTag(this.url.publishStatus, {
        id: record.id,
        status: checked ? 1 : 0
      }).then(res => {
        if (res.success) {
          this.getList(1);
          this.$message.success(res.message);
        } else {
          this.getList(1);

          this.$message.error(res.message);
        }
      });
    },
    // 导出excel
    handleExportExcel(fileName) {
      console.log(this.wid);
      let wid = this.wid;
      // if (this.id == '') {
      //   wid = this.wid;
      // } else {
      //   wid = this.id;
      // }
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件';
      }
      downFile(this.url.exportXlsUrl, { id: wid }).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleChange() {
      // const { file, fileList } = info;
      // let status = file.status;
      // if (status == 'done') {
      if (this.fileList.length == 0) {
        return;
      }
      let formData = new FormData();
      formData.set('file', this.fileList[0]);
      formData.set('id', this.wid);
      uploadAction(this.url.importExcelUrl, formData)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          this.$message.error(err.message);
          this.fileList = [];
          this.showDialog = false;
        });
    },
    //导入
    exportFile(record) {
      console.warn(record);
      this.exportVisible = true;
      this.wid = record.id;
    },
    handleOk() {
      this.handleChange();
      this.exportVisible = false;
    },
    handleCancel() {
      this.exportVisible = false;
    },
    handleCancel() {
      this.exportVisible = false;
    },
    initDictConfig() {},

    channel() {
      this.showDialog = true;
    },
    //删除
    handlDelete(record) {
      let that = this;
      let id = record.id;
      that.$confirm({
        title: '提示',
        content: '确定要删除吗',
        onOk: function() {
          postAction(that.url.delete, { id: id }).then(res => {
            if (res.success) {
              that.getList();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    },
    //问卷详情
    handleParticulars(record) {
      let id = record.id;
      let that = this;
      postAction(that.url.particulars, { id: id }).then(res => {
        console.log(res);
        if (res.result == '' || res.result == null) {
          return this.$message.warning('暂无数据');
        } else {
          if (res.success) {
            that.$refs.questionnaire.visibleShow = true;
            that.particulars = res.result;
          }
        }
      });
    },
    formson(val) {
      this.visibleShow = val;
    },
    // 初始化
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      postTag(that.url.list, params)
        .then(res => {
          that.loading = true;
          if (res.success) {
            if (res.result.records) {
              res.result.records.map(item => {
                item.status = item.status == 0 ? false : true;
              });
            }
            that.dataSource = res.result.records;
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //添加
    handleAdd() {
      this.idns = 0;
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    // 编辑
    handleEdit(record) {
      console.log(record);
      this.idns = 1;
      // record.isuse = record.isuse == '1' ? '启用' : '不启用';
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    // 批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        let that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then(res => {
              if (res.success) {
                that.getList(1);
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发

      this.ipagination = pagination;
      this.getList();
    },
    //excel转换
    productToLead() {
      this.showLead = true;
    },
    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    // upload() {
    //   let formData = new FormData();
    //   this.uploading = true;
    //   formData.set('file', this.fileList[0]);
    //   uploadAction(this.url.importExcelUrl, formData)
    //     .then(res => {
    //       if (res.success) {
    //         this.$message.success(res.message);
    //       } else {
    //         this.$message.error(res.message);
    //       }
    //     })
    //     .finally(() => {
    //       this.uploading = false;
    //       this.fileList = [];
    //       this.showDialog = false;
    //       this.searchQuery();
    //     });
    // },
    handleBatchAudit: function() {
      if (!this.url.auditBatch) {
        this.$message.error('请设置url.checkSuccess属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '提示',
          content: '确定对勾选数据进行审核吗?',
          onOk: function() {
            that.loading = true;
            getAction(that.url.auditBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },

    audit() {},
    recheck() {}
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
